<template lang="pug">
  v-container
    v-row
      v-col
        v-list
          v-list-item(
            v-for="association in associations"
            :key="association.id"
            @click="onClick({ association })")
            v-list-item-avatar
              v-img(
                :src="association.user.image.src"
                :src-lazy="association.user.image.srcLazy")
            v-list-item-content {{ association.user.name }}
            v-list-item-icon
              v-icon {{ mdiChevronRight }}
    v-row
      v-col
        v-alert(
          type="info"
          :color="$theme.background.color") Yako ne soutient pas d'autres associations de ce thème. Aidez nous à en trouver !
</template>

<script>
import { computed } from '@vue/composition-api'
import { page } from '@iez/core'
import data from '@iez/lib/data/'
import router, { routeCurrent } from '@iez/core/router/'
import { mdiChevronRight } from '@mdi/js'
import user from '@iez/lib/user/'
import addPropertyIfExists from '@iez/lib/add-property-if-exists/'

const route = {
  path: `/explore-theme/:id`,
  name: `ExploreTheme`
}

export default {
  ...route,

  setup () {
    page.topBar.set({
      title: computed(
        () => theme.value?.name
      )
    })

    const associations = data.get({
      root: `associations`,
      random: true,
      fields: [
        `id`, {
          user: [
            `id`,
            `name`, {
              image: [
                `id`,
                `src`,
                `srcLazy`
              ]
            }
          ]
        }
      ],
      request: {
        args: {
          seed: `${Math.random()}`
        },
        where: {
          associationsThemes: {
            themeId: {
              _eq: routeCurrent.params.id
            }
          }
        }
      }
    })
    const theme = data.get({
      root: `themes`,
      one: true,
      fields: [
        `id`,
        `name`
      ],
      request: {
        where: {
          id: {
            _eq: routeCurrent.params.id
          }
        }
      }
    })

    const onClick = ({ association }) => {
      router.push({
        name: `Profile`,
        params: {
          ...addPropertyIfExists({
            name: `id`,
            value: user.id === association.user.id
              ? null
              : association.user.id
          })
        }
      })
    }

    return {
      associations,
      mdiChevronRight,
      onClick
    }
  }
}
</script>
